import axios from 'axios'

export const getBackupDatabase = () => {
  return axios.get('/finance/backupDatabase/get', )
}

export const prepareBackupDatabase = (data) => {
  return axios.post('/finance/backupDatabase/prepare', data)
}
